/**
 * useIjwForcedState — display-only forced screen state for local IJW tests.
 * Shaped by: Prompt 23.
 * Invariants: display-only; emulator-only; never in a production bundle.
 * Never writes. Never skips an access check. Forcing no-permission does not
 * grant or revoke access. Forcing empty hides data from display and does not
 * delete it. screenId is a static screen name, never a document id.
 * Related: src/utils/isE2eHookBuild.js, D-12-01 (REACT_APP_USE_FIREBASE_EMULATORS).
 */
import { useMemo } from "react";
import { IS_E2E_HOOK_BUILD } from "../../utils/isE2eHookBuild";

const FORCED_STATES = new Set(["loading", "empty", "error", "noPermission"]);

/**
 * @param {string} screenId Static screen name. Never a document id.
 * @returns {"loading"|"empty"|"error"|"noPermission"|null}
 */
export function useIjwForcedState(screenId) {
  const search = typeof window === "undefined" ? "" : window.location.search;
  const hostname = typeof window === "undefined" ? "" : window.location.hostname;

  return useMemo(() => {
    if (IS_E2E_HOOK_BUILD) {
      if (process.env.REACT_APP_IJW_TEST_SWITCHES !== "true") return null;
      if (process.env.REACT_APP_USE_FIREBASE_EMULATORS !== "true") return null;
      if (hostname !== "localhost" && hostname !== "127.0.0.1") return null;
      const params = new URLSearchParams(search);
      const state = params.get("ijwState");
      if (params.get("ijwScreen") !== screenId) return null;
      if (!FORCED_STATES.has(state)) return null;
      return state;
    }
    return null;
  }, [hostname, screenId, search]);
}
